export const DEBUG_ACTION_NAME = 'Complete with LLM'

export enum PtolemySearchSource {
  Ptolemy = 'ptolemy',
  Confluence = 'confluence',
}
